// components/VenueDetails.js
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function VenueDetails() {
  const [venue, setVenue] = useState(null);
  const { venueId } = useParams();
  const { currentUser } = useAuth();
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    if (!API || !venueId || !currentUser?.uid) return;

    fetch(`${API}/venues/${venueId}`, {
      headers: {
        FirebaseId: currentUser.uid,
        Authorization: 'tamara_admin'
      }
    })
      .then(response => response.json())
      .then(data => setVenue(data))
      .catch(error => console.error('Error fetching venue details:', error));
  }, [API, venueId, currentUser?.uid]);

  if (!venue) return <div>Loading...</div>;

  return (
    <div>
      <h2>{venue.name}</h2>
      <p>City: {venue.city}</p>
      <p>Address: {venue.address}</p>
      <p>Phone: {venue.phone_number}</p>
      <p>Email: {venue.email}</p>
    </div>
  );
}

export default VenueDetails;
